import { createGenericDispatcher } from '../../../../action/action-dispatcher-factory';

import * as Api from '../../../../api/api';

export const loadCurrentBillingUsage = (accountId: number) =>
  createGenericDispatcher({
    name: 'GET_CURRENT_BILLING_USAGE',
    loadFunction: () => Api.get(`/account-billing/usage?accountId=${accountId}`),
    args: { accountId },
  });
